var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing-here-block"},[_vm._v("\n  "+_vm._s(_vm.__('No preview for this file type'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }